<template>
    <template v-if="pageListChild == 'modorderrecord'">
      <!-- 修改完工回報 -->
      <modOrderRecord></modOrderRecord>
    </template>
    <template v-else-if="pageListChild == 'addorderrecord'">
      <!-- 新增完工回報 -->
      <addOrderRecord></addOrderRecord>
    </template>
  </template>
  
  <script>
  import modOrderRecord from "@/components/orderManagement/orderDataRecord/modOrderRecord";
  import addOrderRecord from "@/components/orderManagement/orderDataRecord/addOrderRecord";
  import { inject } from "vue";
  export default {
    components: {
      modOrderRecord,
      addOrderRecord,
    },
    setup() {
      const pageListChild = inject("pageListChild");
  
      return {
        pageListChild,
      };
    },
  };
  </script>
  
  <style></style>
  